export const GET_PROFILES = "GET_PROFILES";
export const SET_PROFILES = "SET_PROFILES";

export const API_ERROR = "PROFILES_API_ERROR";

export const CREATE_PROFILES = "CREATE_PROFILES";
export const CREATED_PROFILES = "CREATED_PROFILES";

export const RESET_PROFILES = "RESET_PROFILES";

export const GET_PROFILE = "GET_PROFILE";
export const SET_PROFILE = "SET_PROFILE";

export const EDIT_PROFILE = "EDIT_PROFILE";
export const EDIT_PROFILE_SUCCESS = "EDIT_PROFILE_SUCCESS";

export const DELETE_PROFILE = "DELETE_PROFILE";
export const DELETE_PROFILE_SUCCESS = "DELETE_PROFILE_SUCCESS";
